/**
 * Route constants: single source of truth for navigable paths.
 *
 * Every deep-link to intercompany or tax pages must use these constants,
 * not raw string literals. A static test enforces this.
 */

export const ROUTES = {
  INTERCOMPANY: '/intercompany',
  TAX_RESERVES: '/tax',
  ENTITIES_ADMIN: '/entities-admin',
  ATTENTION: '/attention',
  DASHBOARD: '/dashboard',
  GROUP: '/dashboard',
  PROFIT_LOSS: '/profit-loss',
  BANKING_BALANCES: '/banking/balances',
  BANKING_TRANSACTIONS: '/banking/transactions',
  BANKING_RECONCILIATION: '/banking/reconciliation',
  BANKING_RULES: '/banking/rules',
  PERSONAL_BANKING_BALANCES: '/personal/banking/balances',
  PERSONAL_BANKING_TRANSACTIONS: '/personal/banking/transactions',
  PERSONAL_BANKING_RECONCILIATION: '/personal/banking/reconciliation',
  ASSETS_LIABILITIES: '/assets-liabilities',
  PERSONAL_NET_WORTH: '/personal/net-worth',
};
